import { reactive } from "vue";

export const store = reactive({
	navBarHeight: 0,
	subnavBarHeight: 0,
	navDropdownOpen: false
});

export const mutations = {
	changeNavBarHeight(newHeight) {
		store.navBarHeight = newHeight;
	},
	changeSubnavBarHeight(newHeight) {
		store.subnavBarHeight = newHeight;
	},
	toggleNavDropdown() {
		store.navDropdownOpen = !store.navDropdownOpen;
	},
	closeNavDropdown() {
		store.navDropdownOpen = false;
	},
	openNavDropdown() {
		store.navDropdownOpen = true;
	}
};
